import {
    Component,
    EventEmitter,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    Output
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthorizationResponse } from '../../../../core/model/authorization/authorization-response.model';
import { AuthorizationSecurityError } from '../../../../core/model/authorization/authorization-security-error.enum';
import { DOCUMENT } from '@angular/common';
import { ApplicationFederateAuthData } from '../../../../core/model/authorization/app-federate-auth-data.model';

/**
 * Component for request authorization. Displays MEP authorization url in iframe.
 *
 * See https://drive.google.com/file/d/0B3KxDK7A5VTPeUtoMlEya3VZLU0/view?ts=5a2508e5
 */
@Component({
    selector: 'ssf-authorization-dialog',
    template: require('./authorization-dialog.component.html'),
    styles: [require('./authorization-dialog.component.scss')],
})
export class AuthorizationDialogComponent implements OnInit, OnDestroy {
    public i18n = 'AUTHORIZATION-DIALOG.';

    @Input() public signInfo: ApplicationFederateAuthData;
    @Output() public onHide = new EventEmitter<boolean>();
    @Output() public onMessage = new EventEmitter<AuthorizationResponse>();
    @Output() public onAuthorizationSecurityError = new EventEmitter<AuthorizationSecurityError>();
    @Input() public lang: string; // required by MEP

    public mepUrl: HTMLAnchorElement;
    public urlResult: any;
    private fnc;

    public visible = false;

    constructor(public sanitizer: DomSanitizer, @Inject(DOCUMENT) private document: any) {
        // see https://stackoverflow.com/questions/41444343/angular-2-window-postmessage
        this.fnc = this.handleMessage.bind(this);

        if (window.addEventListener) {
            window.addEventListener('message', this.fnc, false);
        } else {
            (<any>window).attachEvent('onmessage', this.fnc);
        }
    }

    ngOnDestroy(): void {
        window.removeEventListener('message', this.fnc);
    }

    parseHash(hash: string): any {
        return hash
            .split('&')
            .map( el => el.split('=') )
            .reduce( (acc, cur) => { acc[cur[0]] = cur[1]; return acc; }, {} );
    }

    handleMessage(messageEvent) {

        // Redux extension posts messages also; this should stop unwanted events; for local debugging purposes only
        if (!messageEvent.data.mep_id  ||  !messageEvent.data.event_name) {
            return;
        }

        // Kontrola shody origin z iframe url a z přijaté správy
        if (messageEvent.origin !== `${this.mepUrl.protocol}//${this.mepUrl.hostname}`) {
            console.warn('Check didn\'t pass ', messageEvent.origin, `${this.mepUrl.protocol}//${this.mepUrl.hostname}`);
            this.onAuthorizationSecurityError.emit(AuthorizationSecurityError.ORIGIN_NOT_SAME);
            return;
        }

        let ftaMessage: AuthorizationResponse = messageEvent.data;
        // Kontrola shody id transakce
        const urlMepId = this.parseHash(this.mepUrl.hash).mep_id;
        if (ftaMessage.mep_id !== urlMepId) {
            this.onAuthorizationSecurityError.emit(AuthorizationSecurityError.MEP_ID_NOT_SAME);
            return;
        }

        if (ftaMessage.event_name) {
            this.onMessage.emit(ftaMessage);
        }
    }

    ngOnInit(): void {
       if (this.signInfo.signingUrl  &&  this.signInfo.signingUrl.length > 0) {
            let url = `${this.signInfo.signingUrl}&origin=${window.location.origin}`;
            try {
                this.mepUrl = this.createHrefElement(url);
                this.urlResult = this.sanitizer.bypassSecurityTrustResourceUrl(this.mepUrl.href)
            } catch (err) {
                console.error(err);
            }
        }

        // http://youtrack.csin.cz/issue/SSF-225
        // Autorizacni dialog se objevuje pouze poprve - podruhe zustane viditelna pouze zasedla pruhledna vrstva
        setTimeout(() => {
            this.visible = true;
        }, 500);

    }

    /**
     * URL object is not available in Internet Explorer: https://developer.mozilla.org/en-US/docs/Web/API/URL/URL
     * This is an alternative way to parse URL provided by SSF BE.
     * @param mepUrl url part of signInfo from backend
     * @return {HTMLAnchorElement}
     */
    private createHrefElement(mepUrl): HTMLAnchorElement {
        let url = this.document.createElement('a');
        url.href = mepUrl;
        return url;
    }

    /**
     * Dialog has been closed.
     */
    hide() {
        this.onHide.emit(true);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/components/authorization-dialog/authorization-dialog.component.ts